/**/
import React from "react"
import { withRouter } from 'react-router-dom'
import { Card, Tabs, Row, Col, Typography, Input, Icon, Button, Table, Spin, Tag, message } from "antd"
import { Auth, API } from "aws-amplify"
import BaseAdmin from "./BaseAdmin"
import moment from 'moment'
import { CSVLink } from 'react-csv'
import { connect } from "react-redux"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"
const { Text } = Typography;
const { TabPane } = Tabs;
const { Search } = Input;

class Dashboard extends React.Component {


    constructor(props) {
        super(props)
        this.state={
            usuarios:[],
            loading_alta:true,
            loading_pending:true,
            loading_payment:true,
            users_count:{},
            loading_uncomplete:true,
            loading_count:true,
            loading_baja:true,
            loading_cbu:true,
            loading_todos:true,
            usuarios_alta:[],
            usuarios_baja:[],
            usuarios_adhesion:[],
            usuarios_todos:[{}],
            usuarios_pending:[],
            usuarios_payment:[],
            usuarios_uncomplete:[],
            last_user_id:null
        }
        this.getUsers = this.getUsers.bind(this);
    }

    componentDidMount() {

        Auth.currentSession()
        .then(response => {
            API.get(
                'test',
                '/root/admindashboard',
                {
                    headers: {
                        Authorization: response.getIdToken().getJwtToken()
                    }
                }
            )
                .then(response => {
                    this.setState({ loading_count: false, users_count: response})
                    })
                })
                .catch(err => {console.log(err)
                message.error('Sesion vencida, vuelve a loguearte por favor')
                this.props.Logout()
                this.props.history.push('/login')}
                )

            .catch(err => {
                message.error('Sesion vencida, vuelve a loguearte por favor')
                this.props.Logout()
                this.props.history.push('/login')
            })

        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/users',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        },
                        queryStringParameters: {
                            index: 'list_incomplete_users_payment_active',
                            value: 'INCOMPLETO'
                        }
                    }
                )
                    .then(response => {
                        let usuariosUncomplete = response.map(usr => {
                            usr["key"] = usr["user_id"]
                            usr["fecha_inicio"]= usr["fecha_inicio"]===null?"2050-12-14":usr["fecha_inicio"]
                            return usr
                        })
                        this.setState({ loading_uncomplete: false, usuarios_uncomplete: usuariosUncomplete })
                    })
                    .catch(err => console.log(err))
            })
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/users',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        },
                        queryStringParameters: {
                            index: 'payment_status',
                            value: 'VENCIDO'
                        }
                    }
                )
                    .then(response => {
                        let usuariosVencidos = response.map(usr => {
                            usr["key"] = usr["user_id"]
                            usr["fecha_inicio"]= usr["fecha_inicio"]===null?"2050-12-14":usr["fecha_inicio"]
                            return usr
                        })
                        this.setState({ loading_payment: false, usuarios_payment: usuariosVencidos })
                    })
                    .catch(err => console.log(err))
            })
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/users',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        },
                        queryStringParameters: {
                            index: 'monotributo_status',
                            value: 'HACER_ALTA'
                        }
                    }
                )
                    .then(response => {
                        let usuariosAlta = response.map(usr => {
                            usr["key"] = usr["user_id"]
                            usr["fecha_inicio"]= usr["fecha_inicio"]===null?"2050-12-14":usr["fecha_inicio"]
                            return usr
                        })
                        this.setState({ loading_alta: false, usuarios_alta: usuariosAlta.filter(us =>us.estado_clave_fiscal ==='ACTIVO') })
                    })
                    .catch(err => console.log(err))
            })
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/users',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        },
                        queryStringParameters: {
                            index: 'monotributo_status',
                            value: 'PENDIENTE_REVISION'
                        }
                    }
                )
                    .then(response => {
                        let usuariosPending = response.map(usr => {
                            usr["key"] = usr["user_id"]
                            usr["fecha_inicio"]= usr["fecha_inicio"]===null?"2050-12-14":usr["fecha_inicio"]
                            return usr
                        })
                        this.setState({ loading_pending: false, usuarios_pending: usuariosPending.filter(us =>us.estado_clave_fiscal ==='ACTIVO') })
                    })
                    .catch(err => console.log(err))
            })
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/users',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        },
                        queryStringParameters: {
                            index: 'status_baja_mono_cancelado',
                            value: 'BAJA'
                        }
                    }
                )
                    .then(response => {
                        let usuariosBaja = response.map(usr => {
                            usr["key"] = usr["user_id"]
                            usr["fecha_inicio"]= usr["fecha_inicio"]===null?"2050-12-14":usr["fecha_inicio"]
                            return usr
                        })
                        this.setState({ loading_baja: false, usuarios_baja: usuariosBaja })
                    })
                    .catch(err => console.log(err))
            })
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/users',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        },
                        queryStringParameters:{
                            index: 'adherido_cbu',
                            value: 'POR_ADHERIR'
                        }
                    }
                )
                    .then(response => {
                        let usuariosCbu = response.map(usr => {
                            usr["key"] = usr["user_id"]
                            usr["fecha_inicio"] = usr["fecha_inicio"]===null?"2050-12-14":usr["fecha_inicio"]
                            return usr
                        })
                        this.setState({loading_cbu: false, usuarios_adhesion: usuariosCbu})
                    })
            })
    }


    getUser(value, index) {
        this.setState({ loading_busqueda: true })
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/users',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        },
                        queryStringParameters: {
                            index: index,
                            value: value
                        }
                    })
                    .then(response => {
                        if (response.length === 0) {
                            message.warn('No se encontró el usuario')
                            this.setState({ loading_busqueda: false })
                        }
                        else {
                            let usuarioBusqueda = response.map(usr => {
                                usr["key"] = usr["user_id"]
                                usr["fecha_inicio"]= usr["fecha_inicio"]===null?"2050-12-14":usr["fecha_inicio"]
                                return usr
                            })
                            message.success('Usuario encontrado')
                            this.setState({ loading_busqueda: false, usuario_busqueda: usuarioBusqueda })
                        }
                    }
                    )
                    .catch(err => {
                        message.error('No se encontro el usuario')
                        this.setState({ loading_busqueda: false })
                    })
            })
    }


    async getUsers(key) {
        let allUsers = []
        if (key === "7") {
            this.setState({ loading_todos: true })
            try {
                let response = await Auth.currentSession();
                let queryStringParameters = {
                    limit: 300
                }
                while (true) {
                    let users = await API.get(
                        'test',
                        '/root/users',
                        {
                            headers: {
                                Authorization: response.getIdToken().getJwtToken()
                            },
                            queryStringParameters: queryStringParameters
                        }
                    )
                    if (users.last !== null) {
                        queryStringParameters['last'] = users.last
                        users.users.map(usr => {
                            usr["key"] = usr["user_id"]
                            usr["fecha_inicio"]= usr["fecha_inicio"]===null?"2050-12-14":usr["fecha_inicio"]
                            allUsers.push(usr)
                            return usr
                        })
                    } else {
                        users.users.map(usr=>{
                            usr['key']= usr['user_id']
                            usr["fecha_inicio"]= usr["fecha_inicio"]===null?"2050-12-14":usr["fecha_inicio"]
                            allUsers.push(usr)
                            return usr
                        })
                        this.setState({ loading_todos: false, usuarios_todos: allUsers })
                        break;
                    }
                }
            }
            catch (e) {
                message.error('Ocurrio un error')
                this.setState({ loading_todos: false })
            }
        }

    }

    render() {
        if (this.state.loading_alta || this.state.loading_baja || this.state.loading_payment || this.state.loading_uncomplete || this.state.loading_pending ||this.state.loading_count || this.state.loading_cbu){
            return(
                <BaseAdmin selected='Admin'>
                    <Row type="flex" justify="space-around" align="middle">
                        <Col style={{minHeight:'360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                </BaseAdmin>
            )
        }

        else {



            let columns = [
                {
                    title: "Usuario",
                    dataIndex: "email",
                    key: "email",
                    width: "20em",
                    //fixed: "left",
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <div style={{ padding: 8 }}>
                            <Input
                                ref={node => {
                                    this.searchInput = node;
                                }}
                                placeholder="Buscar usuario"
                                value={selectedKeys[0]}
                                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                                onPressEnter={() => confirm()}
                                style={{ width: 188, marginBottom: 8, display: 'block' }}
                            />
                            <Button
                                type="primary"
                                onClick={() => confirm()}
                                icon="search"
                                size="small"
                                style={{ width: 90, marginRight: 8 }}
                            >
                                Buscar
                        </Button>
                            <Button
                                onClick={() => clearFilters()}
                                size="small"
                                style={{ width: 90 }}
                            >
                                Reset
                        </Button>
                        </div>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    onFilter: (value, record) => record.email.toString().toLowerCase().includes(value),
                    onFilterDropdownVisibleChange: visible => {
                        if (visible) {
                            setTimeout(() => this.searchInput.select())
                        }
                    }
                },
                {
                    title: "Apellido",
                    dataIndex: "apellido",
                    key: "apellido",
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <div style={{ padding: 8 }}>
                            <Input
                                ref={node => {
                                    this.searchInput = node;
                                }}
                                placeholder="Buscar usuario"
                                value={selectedKeys[0]}
                                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                                onPressEnter={() => confirm()}
                                style={{ width: 188, marginBottom: 8, display: 'block' }}
                            />
                            <Button
                                type="primary"
                                onClick={() => confirm()}
                                icon="search"
                                size="small"
                                style={{ width: 90, marginRight: 8 }}
                            >
                                Buscar
                        </Button>
                            <Button
                                onClick={() => clearFilters()}
                                size="small"
                                style={{ width: 90 }}
                            >
                                Reset
                        </Button>
                        </div>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    onFilter: (value, record) => record.apellido.toString().toLowerCase().includes(value),
                    onFilterDropdownVisibleChange: visible => {
                        if (visible) {
                            setTimeout(() => this.searchInput.select())
                        }
                    }
                },
                {
                    title: "Nombre",
                    dataIndex: "nombre",
                    key: "nombre",
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <div style={{ padding: 8 }}>
                            <Input
                                ref={node => {
                                    this.searchInput = node;
                                }}
                                placeholder="Buscar usuario"
                                value={selectedKeys[0]}
                                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                                onPressEnter={() => confirm()}
                                style={{ width: 188, marginBottom: 8, display: 'block' }}
                            />
                            <Button
                                type="primary"
                                onClick={() => confirm()}
                                icon="search"
                                size="small"
                                style={{ width: 90, marginRight: 8 }}
                            >
                                Buscar
                        </Button>
                            <Button
                                onClick={() => clearFilters()}
                                size="small"
                                style={{ width: 90 }}
                            >
                                Reset
                        </Button>
                        </div>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    onFilter: (value, record) => record.nombre.toString().toLowerCase().includes(value),
                    onFilterDropdownVisibleChange: visible => {
                        if (visible) {
                            setTimeout(() => this.searchInput.select())
                        }
                    }
                },
                {
                    title: "Teléfono",
                    dataIndex: "telefono",
                    key: "telefono"
                },
                {
                    title: "Estado Usuario",
                    dataIndex: "estado_usuario",
                    key: "estado_usuario",
                    render: (value) => {
                        let color = ""
                        let text = ""
                        switch (value) {
                            case "ACTIVO":
                                color = "green"
                                text = "Activos"
                                break
                            case "INCOMPLETO":
                                color = "grey"
                                text = "Incompleto"
                                break
                            case "BAJA":
                                color = "red"
                                text = "Baja"
                                break
                            case "INACTIVO":
                                color = "orange"
                                text = "Inactivo"
                                break
                            case "BLOQUEADO":
                                color = "yellow"
                                text = "Bloqueado"
                                break
                            default:
                                break
                        }
                        return {
                            children:
                                <Tag color={color}>
                                    {text}
                                </Tag>
                        }
                    },
                    filters: [
                        {
                            text: "Activo",
                            value: "ACTIVO"
                        },
                        {
                            text: "Baja",
                            value: "BAJA"
                        },
                        {
                            text: "Bloqueado",
                            value: "BLOQUEADO"
                        },
                        {
                            text: "Inactivo",
                            value: "INACTIVO"
                        },
                        {
                            text: "Incompleto",
                            value: "INCOMPLETO"
                        }

                    ],
                    filterMultiple: true,
                    onFilter: (value, record) => record.estado_usuario.indexOf(value) === 0

                },
                {
                    title: "Monotributo",
                    dataIndex: "estado_monotributo",
                    key: "estado_monotributo",
                    render: (value)=>{
                        let text=''
                        switch(value) {

                            case "INACTIVO":
                                text= "Inactivo"
                                break
                            case "INCOMPLETO":
                                text= "Incompletos"
                                break
                            case "HACER_ALTA":
                                text= "Hacer Alta"
                                break
                            case "EXCLUIDO":
                                text= "Excluido (no mono)"
                                break
                            case "PENDIENTE_REVISION":
                                text= "Pendiente revisión"
                                break
                            case "ACTIVO":
                                text= "Activo"
                                break
                            case "HACER_BAJA":
                                text= "Hacer Baja"
                                break
                            case "CANCELADO":
                                text= "Cancelado"
                                break
                            case "ERROR_CUIT_INACTIVO":
                                text= "Cuit inactivo"
                                break
                            case "ERROR_RENAPER":
                                text= "Renaper"
                                break
                            case "ERROR_CLAVE_FISCAL_NIVEL_1":
                                text= "Error Clave Fiscal"
                                break
                            case "ERROR_BAJA_OFICIO":
                                text= "Baja Oficio"
                                break
                            case "ERROR_DNI_VENCIDO":
                                text= "DNI Vencido"
                                break
                            case "ERROR_DDJJ_SIN_PRESENTAR":
                                text= "DDJJ"
                                break
                            case "ERROR_EXCLUIDO":
                                text= "Excluido (x afip)"
                                break
                            case "ERROR_OTROS":
                                text= "Error otros"
                                break
                            default:
                                break
                        }
                    return {
                        children:
                         <Tag color={null}>{text}</Tag>
                    }
                    },
                    filters: [
                        {
                            text: "Activo",
                            value: "ACTIVO"
                        },
                        {
                            text: "Baja Oficio",
                            value: "ERROR_BAJA_OFICIO"
                        },                        {
                            text: "Cancelado",
                            value: "CANCELADO"
                        },
                        {
                            text: "Cuit inactivo",
                            value: "ERROR_CUIT_INACTIVO"
                        },
                        {
                            text: "DNI Vencido",
                            value: "ERROR_DNI_VENCIDO"
                        },
                        {
                            text: "DDJJ",
                            value: "ERROR_DDJJ_SIN_PRESENTAR"
                        },
                        {
                            text: "Error Clave Fiscal",
                            value: "ERROR_CLAVE_FISCAL_NIVEL_1"
                        },
                        {
                            text: "Error otros",
                            value: "ERROR_OTROS"
                        },
                        {
                            text: "Excluido (x afip)",
                            value: "ERROR_EXCLUIDO"
                        },
                        {
                            text: "Excluido (no mono)",
                            value: "EXCLUIDO"
                        },
                        {
                            text: "Hacer Alta",
                            value: "HACER_ALTA"
                        },
                        {
                            text: "Hacer Baja",
                            value: "HACER_BAJA"
                        },
                        {
                            text: "Inactivo",
                            value: "INACTIVO"
                        },
                        {
                            text: "Incompletos",
                            value: "INCOMPLETO"
                        },
                        {
                            text: "Pendiente revisión",
                            value: "PENDIENTE_REVISION"
                        },
                        {
                            text: "Renaper",
                            value: "ERROR_RENAPER"
                        },
                    ],
                    filterMultiple: true,
                    onFilter: (value, record) => record.estado_monotributo.indexOf(value) === 0

                },
                {
                    title: "Estado Pago",
                    dataIndex: "estado_pago",
                    key: "estado_pago",
                    render: (value) => {
                        let color = ""
                        let text = ""
                        switch (value) {
                            case "ACTIVO":
                                color = "green"
                                text = "Activos"
                                break
                            case "ACTIVO_PRUEBA":
                                color = "grey"
                                text = "Activo prueba"
                                break
                            case "VENCIDO":
                                color = "red"
                                text = "Vencido"
                                break
                            case "INACTIVO":
                                color = "blue"
                                text = "Inactivo"
                                break
                            case "POR_VENCER":
                                color = "yellow"
                                text = "Por vencer"
                                break
                            case "PAGO_EN_PROCESO":
                                color = "yellow"
                                text = "En proceso"
                                break
                            default:
                                break
                        }
                        return {
                            children:
                                <Tag color={color}>
                                    {text}
                                </Tag>
                        }
                    },
                    filters: [
                        {
                            text: "Activo",
                            value: "ACTIVO"
                        },
                        {
                            text: "Vencido",
                            value: "VENCIDO"
                        },
                        {
                            text: "Por Vencer",
                            value: "POR_VENCER"
                        },
                        {
                            text: "Inactivo",
                            value: "INACTIVO"
                        },
                        {
                            text: "En proceso",
                            value: "PAGO_EN_PROCESO"
                        },
                        {
                            text: "Activo prueba",
                            value: "ACTIVO_PRUEBA"
                        }

                    ],
                    filterMultiple: true,
                    onFilter: (value, record) => record.estado_pago.indexOf(value) === 0

                },
                {
                    title:"Fecha Pago",
                    dataIndex:"fecha_inicio",
                    key:"fecha_inicio",
                     render: (value, row, index) => {
                         return {
                             children: moment(value).format("YYYY-MM-DD")
                         }
                     },
                    sorter: (a, b) => moment(a.fecha_inicio).diff(b.fecha_inicio),
                    defaultSortOrder: 'descend'
                },
                {
                    title:"Fecha Fin",
                    dataIndex:"fecha_fin",
                    key:"fecha_fin",
                    render: (value, row, index) => {
                        const fechaFin = (value === undefined || value == null) ? '' : moment(value).format("YYYY-MM-DD")
                        return {
                            children: fechaFin
                        }
                    },
                    sorter: (a, b) => moment(a.fecha_fin).diff(b.fecha_fin),
                    defaultSortOrder: 'descend'
                },
                {
                    title: "Acciones",
                    dataIndex: "actions",
                    key: "actions",
                    render: (text, record, index) => {
                        return {
                            children: <Button onClick={() => this.props.history.push("/edit-user/" + record.user_id)}>
                                Editar
                        </Button>
                        }
                    }
                },

            ]

            let headerCsv = [
                {
                    label:'Apellido',
                    title: 'Apellido',
                    key:'apellido',
                    dataIndex:'apellido'
                },
                {
                    label:'Nombre',
                    title: 'Nombre',
                    key:'nombre',
                    dataIndex:'nombre'
                },
                {
                    label:'Telefono',
                    title:'Telefono',
                    key:'telefono',
                    dataIndex:'telefono'
                },
                {
                    label:'Email',
                    title: 'Email',
                    key:'email',
                    dataIndex:'email'
                },
                {
                    label:'Cuit',
                    title: 'Cuit',
                    key:'cuit',
                    dataIndex:'cuit'
                },
                {
                    label:'Estado Usuario',
                    title: 'Estado Usuario',
                    key:'estado_usuario',
                    dataIndex:'estado_usuario'
                },
                {
                    label:'Estado Monotributo',
                    title: 'Estado Monotributo',
                    key:'estado_monotributo',
                    dataIndex:'estado_monotributo'
                },
                {
                    label:'Estado Pago',
                    title: 'Estado Pago',
                    key:'estado_pago',
                    dataIndex:'estado_pago'
                },
                {
                    label:'Estado Clave Fiscal',
                    title: 'Estado Clave Fiscal',
                    key:'estado_clave_fiscal',
                    dataIndex:'estado_clave_fiscal'
                },
                {
                    label:'Fecha Pago',
                    title: 'Fecha Pago',
                    key:'fecha_inicio',
                    dataIndex:'fecha_inicio'
                }
            ]
let usuariosAltaPorHacer = this.state.usuarios_alta.concat(this.state.usuarios_pending)

            return (


                <BaseAdmin
                    selected="admin"
                >

                    <Row gutter={[8, 8]} type="flex" justify="center">
                        <Col lg={4} xs={24}>
                            <Card
                                title={'Estado Clientes'}
                                style={{ height: '100%' }}
                            >
                                <Text strong> {this.state.users_count.estado_usuario['ACTIVO']} Usuarios Activos</Text>
                                <br />
                                <Text strong> {this.state.users_count.estado_usuario['INACTIVO']} Usuarios Inactivos</Text>

                            </Card>
                        </Col>
                        <Col lg={4} xs={24}>
                            <Card
                                title={'Pendientes de alta'}
                                style={{ height: '100%' }}
                            >
                                <Text strong> {this.state.users_count.estado_usuario['PENDIENTE_REVISION']} Completos</Text>
                                <br />
                                <Text strong> {this.state.users_count.estado_monotributo['INCOMPLETO']} Incompletos</Text>
                            </Card>
                        </Col>
                        <Col lg={4} xs={24}>
                            <Card
                                title={'Monotributos por crear'}
                                style={{ height: '100%' }}
                            >
                                <Text strong> {this.state.users_count.estado_monotributo['HACER_ALTA']} Usuarios</Text>
                            </Card>
                        </Col>
                        <Col lg={4} xs={24}>
                            <Card
                                title={'Clientes plan vencido'}
                                style={{ height: '100%' }}
                            >
                                <Text strong>{this.state.users_count.estado_pago['VENCIDO']} Usuarios </Text>
                            </Card>
                        </Col>
                        <Col lg={4} xs={24}>
                            <Card
                                title={'Pendientes de adhesión'}
                                style={{ height: '100%' }}
                            >
                                <Text strong>{this.state.users_count.estado_cbu['POR_ADHERIR']} Usuarios </Text>
                            </Card>
                        </Col>
                        <Col lg={4} xs={24}>
                            <Card
                                title={'Solicitudes de Baja'}
                                style={{ height: '100%' }}
                            >
                                <Text strong>{this.state.users_count.estado_usuario['BAJA']} Usuarios </Text>
                            </Card>
                        </Col>
                    </Row>
                    <Card style={{ marginTop: '10px' }}>
                        <Row>
                            <Col lg={24}>

                                <Tabs defaultActiveKey="1" onChange={this.getUsers}>
                                    <TabPane tab="Pendientes de Alta" key="1">
                                        <Table
                                            columns={columns}
                                            dataSource={usuariosAltaPorHacer}
                                            pagination={{
                                                showSizeChanger: true,
                                                pageSizeOptions: ['5', '10', '20', '50', '100'],
                                                defaultPageSize: 5,
                                                hideOnSinglePage: true
                                            }}
                                            loading={this.state.loading_alta}
                                            scroll={{ x: "max-content" }}
                                        />
                                        <Button
                                            loading={this.state.loading_alta}
                                            type="primary"
                                            disabled={false}
                                        >
                                        <CSVLink
                                            data={usuariosAltaPorHacer}
                                            headers={headerCsv}
                                            filename={"Usuarios pendientes"+new Date()+".csv"}
                                            style={{marginTop:'20px', marginBottom:'10px'}}
                                        >
                                            Descargar Usuarios Pendientes
                                        </CSVLink>
                                        </Button>

                                    </TabPane>

                                    <TabPane tab='Usuarios incompletos' key="2">
                                        <Table
                                            columns={columns}
                                            dataSource={this.state.usuarios_uncomplete}
                                            pagination={{
                                                showSizeChanger: true,
                                                pageSizeOptions: ['5', '10', '20', '50', '100'],
                                                defaultPageSize: 5,
                                                hideOnSinglePage: true
                                            }}
                                            loading={this.state.loading_uncomplete}
                                            scroll={{ x: "max-content" }}
                                        />
                                        <Button
                                            loading={this.state.loading_uncomplete}
                                            type="primary"
                                            disabled={false}
                                        >
                                        <CSVLink
                                            data={this.state.usuarios_uncomplete}
                                            headers={headerCsv}
                                            filename={"Usuarios incompletos"+new Date()+".csv"}
                                            style={{marginTop:'10px', marginBottom:'10px'}}
                                        >
                                            Descargar Usuarios incompletos
                                        </CSVLink>
                                        </Button>
                                    </TabPane>

                                    <TabPane tab="Pedidos de Baja" key="3">
                                        <Table
                                            columns={columns}
                                            dataSource={this.state.usuarios_baja}
                                            pagination={{
                                                showSizeChanger: true,
                                                pageSizeOptions: ['5', '10', '20', '50', '100'],
                                                defaultPageSize: 5,
                                                hideOnSinglePage: true
                                            }}
                                            loading={this.state.loading_baja}
                                            scroll={{ x: "max-content" }}

                                        />
                                        <Button
                                            loading={this.state.loading_baja}
                                            type="primary"
                                            disabled={false}
                                        >
                                        <CSVLink
                                            data={this.state.usuarios_baja}
                                            headers={headerCsv}
                                            filename={"Usuarios baja"+new Date()+".csv"}
                                            style={{marginTop:'10px', marginBottom:'10px'}}
                                        >
                                            Descargar Usuarios baja
                                        </CSVLink>
                                        </Button>

                                    </TabPane>

                                    <TabPane tab="Pagos vencidos" key="4">
                                        <Table
                                            columns={columns}
                                            dataSource={this.state.usuarios_payment}
                                            pagination={{
                                                showSizeChanger: true,
                                                pageSizeOptions: ['5', '10', '20', '50', '100'],
                                                defaultPageSize: 5,
                                                hideOnSinglePage: true
                                            }}
                                            loading={this.state.loading_payment}
                                            scroll={{ x: "max-content" }}

                                        />
                                        <Button
                                            loading={this.state.loading_payment}
                                            type="primary"
                                            disabled={false}
                                        >
                                        <CSVLink
                                            data={this.state.usuarios_payment}
                                            headers={headerCsv}
                                            filename={"Usuarios vencidos"+new Date()+".csv"}
                                            style={{marginTop:'10px', marginBottom:'10px'}}
                                        >
                                            Descargar Usuarios vencidos
                                        </CSVLink>
                                        </Button>

                                    </TabPane>

                                    
                                    <TabPane tab="Pendientes adhesión" key="5">
                                        <Table
                                            columns={columns}
                                            dataSource={this.state.usuarios_adhesion}
                                            pagination={{
                                                showSizeChanger: true,
                                                pageSizeOptions: ['5', '10', '20', '50', '100'],
                                                defaultPageSize: 5,
                                                hideOnSinglePage: true
                                            }}
                                            loading={this.state.loading_cbu}
                                            scroll={{ x: "max-content" }}

                                        />
                                        <Button
                                            loading={this.state.loading_cbu}
                                            type="primary"
                                            disabled={false}
                                        >
                                        <CSVLink
                                            data={this.state.usuarios_adhesion}
                                            headers={headerCsv}
                                            filename={"Usuarios adhesion"+new Date()+".csv"}
                                            style={{marginTop:'10px', marginBottom:'10px'}}
                                        >
                                            Descargar Usuarios con solicitud de adhesión
                                        </CSVLink>
                                        </Button>

                                    </TabPane>
                                    
                                    <TabPane tab='Buscar Usuario' key='6'>
                                        <Card style={{ marginBottom: 15, borderTop: '3px', marginTop: 10 }}>
                                            <Col lg={12} style={{ marginBottom: 10, marginTop: 10 }}>
                                                <Search style={{ width: 200 }} placeholder={'Email'} onSearch={value => this.getUser(value.toLowerCase(), 'email')}></Search>
                                            </Col>
                                            <Col lg={12} style={{ marginBottom: 10, marginTop: 10 }}>
                                                <Search style={{ width: 200 }} placeholder={'Cuit'} onSearch={value => this.getUser(value, 'cuit')}></Search>
                                            </Col>
                                            <Col lg={12} style={{ marginBottom: 10, marginTop: 10 }}>
                                                <Search style={{ width: 200 }} placeholder={'MercadoPago ID'} onSearch={value => this.getUser(value, 'mp_customer_card_id')}></Search>
                                            </Col>
                                            <Col lg={12} style={{ marginBottom: 10, marginTop: 10 }}>
                                                <Search style={{ width: 200 }} placeholder={'Teléfono'} onSearch={value => this.getUser(value, 'telefono')}></Search>
                                            </Col>
                                        </Card>

                                        <Table
                                            columns={columns}
                                            dataSource={this.state.usuario_busqueda }
                                            pagination={{
                                                showSizeChanger: true,
                                                pageSizeOptions: ['5'],
                                                defaultPageSize: 5,
                                                hideOnSinglePage: true
                                            }}
                                            loading={this.state.loading_busqueda}
                                            scroll={{ x: "max-content" }}
                                        />

                                    </TabPane>
                                    <TabPane tab="Todos" key="7">
                                        <Table
                                            columns={columns}
                                            dataSource={this.state.usuarios_todos}
                                            loading={this.state.loading_todos}
                                            pagination={{
                                                showSizeChanger: true,
                                                pageSizeOptions: ['10', '20', '50', '100'],
                                                defaultPageSize: 5,
                                                hideOnSinglePage: true
                                            }}
                                            scroll={{ x: "max-content" }}
                                        />
                                         <Button
                                        loading={this.state.loading_todos}
                                        type="primary"
                                        disabled={false}
                                    >
                                    <CSVLink
                                        data={this.state.usuarios_todos}
                                        headers={headerCsv}
                                        filename={"Usuarios todos"+new Date()+".csv"}
                                        style={{marginTop:'10px', marginBottom:'10px'}}
                                    >
                                        Descargar todos los Usuarios
                                    </CSVLink>
                                    </Button>
                                    </TabPane>

                                </Tabs>
                            </Col>
                        </Row>
                    </Card>
                </BaseAdmin>

            );
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Dashboard));
